// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"380":"c06dbccebfde3c79","684":"6cdd7b732324aad1","745":"2edd391dd1f55fab"}[chunkId] + ".js";
};